import styled from 'styled-components'
import moment from 'moment'

import EmptyPage from 'components/empty-page/EmptyPage'
import Separator from 'components/separator/Separator'
import Avatar, { AvatarSize } from 'components/avatar/Avatar'
import { TITLES } from 'locales/locales'
import { useTranslation } from 'react-i18next'
import { FixMeLater } from 'types'
import CustomIcon from 'components/icon/CustomIcon'
import { icons } from 'utils/icons'
import CustomText from 'components/text/CustomText'
import colors from 'utils/colors'

interface IReadStatusPanelProps {
  users: FixMeLater
  myId: FixMeLater
  message: FixMeLater
  onBackToThread?: FixMeLater
}

const ReadStatusPanel = ({ message, users, myId, onBackToThread }: IReadStatusPanelProps) => {
  const { t } = useTranslation()
  const messageDate = message?.sentAt || message?.createdAt
  const formattedDate = messageDate ? moment(messageDate).format('DD MMMM YYYY HH:mm:ss') : null

  return (
    <Wrapper>
      <>
        {formattedDate && (
          <MessageDateWrapper>
            <CustomText typography="body3" color={colors.gray100}>
              {formattedDate}
            </CustomText>
          </MessageDateWrapper>
        )}
        {message?.type === 'THREAD' && (
          <>
            <StyledBackButton onClick={onBackToThread}>
              <CustomIcon height="16px" width="16px" source={icons.chevronLeftIconBig} />
              <CustomText typography="body2">{t(TITLES.BACK_THREAD)}</CustomText>
            </StyledBackButton>
            <CustomText typography="header1">{t(TITLES.MESSAGE_TITLE)}</CustomText>
          </>
        )}
        <SectionTitle>
          {t(TITLES.READS_TITLE)} ({message?.readers?.length})
        </SectionTitle>
        {message?.readers?.length > 0 ? (
          message?.readers?.map((reader: FixMeLater) => {
            if (reader === myId) return null

            const user = users[reader]
            if (!user) return null

            return (
              <UserRow key={user._id}>
                <Avatar
                  source={user?.avatar}
                  text={user.fullname}
                  size={AvatarSize.average}
                  status={user?.status}
                />
                <UserName>{user.fullname}</UserName>
              </UserRow>
            )
          })
        ) : (
          <EmptyPage value={t(TITLES.EMPTY_READS_TITLE)} isEmptyRead />
        )}
        <Separator />
        <SectionTitle>
          {t(TITLES.READES_SENT_TO_TITLE)} ({Object.keys(users)?.length - message?.readers?.length})
        </SectionTitle>
        {Object.keys(users)?.map((member: FixMeLater) => {
          if (message?.readers?.includes(member)) return null
          const user = users[member]
          if (!user) return null
          return (
            <UserRow key={member}>
              <Avatar
                source={user?.avatar}
                text={user.fullname}
                size={AvatarSize.average}
                status={user?.status}
              />
              <UserName>{user.fullname}</UserName>
            </UserRow>
          )
        })}
      </>
    </Wrapper>
  )
}

export default ReadStatusPanel

const Wrapper = styled.div`
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  padding: 16px;
`

const MessageDateWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 4px;
`

const SectionTitle = styled.h4`
  margin-top: 16px;
  font-size: 16px;
  font-weight: bold;
  color: #444;
`

const UserRow = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
`

const UserName = styled.span`
  font-size: 17px;
  color: #333;
  margin-left: 15px;
  font-weight: 500;
`
const StyledBackButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 16px;
  margin-top: 16px;
  color: ${colors.primaryVime};
  &:hover {
    color: ${colors.primaryVime};
    text-decoration: underline;
  }
`
